import * as React from "react";
import type { SVGProps } from "react";
const SvgDanishAirTransport = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 50 50"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fill="#fff"
      d="M48 25c0 12.426-10.074 22.5-22.5 22.5S3 37.426 3 25 13.073 2.5 25.5 2.5 48 12.574 48 25"
    />
    <path
      stroke="#fff"
      strokeWidth={0.63}
      d="M48 25c0 12.426-10.074 22.5-22.5 22.5S3 37.426 3 25 13.073 2.5 25.5 2.5 48 12.574 48 25z"
    />
    <path
      fill="#f9a91f"
      d="M32.019 24.334c3.023 2.381 5.57 4.694 7.414 6.703 1.708-.718 5.146-2.04 8.124-2.516.688-4.33.076-8.775-1.73-12.75z"
    />
    <path
      fill="#fcd213"
      d="M40.022 41.98a22 22 0 0 0 3.77-4.163 22.4 22.4 0 0 0 2.624-4.965l-4.474 3.673z"
    />
    <path
      fill="#1f4fa2"
      d="M35.926 36.04c-2.517-1.042-5.563-2.644-8.836-4.67l-3.31 15.886c4.346.34 8.73-.605 12.561-2.728-.566-2.948-.498-6.635-.415-8.487"
    />
    <path
      fill="#d22027"
      d="M19.117 45.911c-.62-.763.008-15.969.174-19.907-7.61-5.774-12.516-11.948-12.176-13.597-6.907 10.075-4.428 23.869 5.608 30.881a22.3 22.3 0 0 0 7.18 3.326c-.355-.272-.635-.514-.786-.703"
    />
    <path
      fill="#009a68"
      d="M24.316 18.832c3.628-1.504 17.717-7.3 18.646-6.976.227.076.56.264.93.498a22.2 22.2 0 0 0-5.578-5.615C28.277-.282 14.477 2.1 7.373 12.038c1.427-.877 8.917 1.61 16.943 6.794"
    />
  </svg>
);
export default SvgDanishAirTransport;
